import React from 'react';
import PropTypes from 'prop-types';
import AppIcon from '../../components/AppIcon';

const LeftNavButton = props => (
  <div className={props.className} onClick={props.onClick}>
    <AppIcon iconName="ARROW_UP" containerClass="arrow-icon" />
  </div>
);


LeftNavButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};

LeftNavButton.defaultProps = {
  className: '',
  onClick: () => {}
};

export default LeftNavButton;



// WEBPACK FOOTER //
// ./src/containers/TimeSlots/LeftNavButton.jsx